import { create } from "zustand";

export const useForecastStore = create((set) => ({
  latestForecast: {},
  initialSortBy: {},
  historicPredictionsToUse: [],
  
  setForecastData: (data) => set({
    latestForecast: data.latestForecast,
    historicPredictionsToUse: data.historicPredictionsToUse,
    initialSortBy: data.initialSortBy,
  }),
}));
